import * as JSONMapper from "json-mapper";
import {JSONMapped, jsonProperty} from "json-mapper-reflect";
import * as moment from "moment";


export class AvdbLicenseInfo extends JSONMapped() {
	constructor(data?: Partial<AvdbLicenseInfo>) {
		super();
		Object.assign(this, data);
	}

	@jsonProperty()
	key: string;

	@jsonProperty(JSONMapper.timestampFromISO)
	textUpdatedAt: moment.Moment;
}

export class AvdbFileInfo extends JSONMapped() {
	constructor(data?: Partial<AvdbFileInfo>) {
		super();
		Object.assign(this, data);
	}

	@jsonProperty()
	destination: string;

	@jsonProperty()
	fileSize: number;

	@jsonProperty()
	subregionID: string;

	@jsonProperty()
	url: string;

	@jsonProperty()
	lastUpdatedIssue: string;
}

export class LatLon extends JSONMapped() {
	constructor(data?: Partial<LatLon>) {
		super();
		Object.assign(this, data);
	}

	@jsonProperty()
	lat: number;

	@jsonProperty()
	lon: number;

	toTuple(): [number, number] {
		return [this.lat, this.lon];
	}
}

export class AvdbSubregionMapDisplayInfo extends JSONMapped() {
	constructor(data?: Partial<AvdbSubregionMapDisplayInfo>) {
		super();
		Object.assign(this, data);
	}

	@jsonProperty()
	description: string;

	@jsonProperty()
	fillColor: string;

	@jsonProperty(JSONMapper.arrayOf(JSONMapper.arrayOfClass(LatLon)))
	paths: Array<Array<LatLon>>;
}

export class AvdbSubregion extends JSONMapped() {
	constructor(data?: Partial<AvdbSubregion>) {
		super();
		Object.assign(this, data);
	}

	@jsonProperty()
	id: string;

	@jsonProperty(JSONMapper.arrayOfClass(LatLon))
	path: Array<LatLon>;

	@jsonProperty()
	territories: Array<string>;
}

export class AvdbIssueManifest extends JSONMapped() {
	constructor(data?: Partial<AvdbIssueManifest>) {
		super();
		Object.assign(this, data);
	}

	@jsonProperty()
	issueType: string; // TODO: enum

	@jsonProperty()
	totalFileSize: number;

	@jsonProperty()
	url: string;

	@jsonProperty()
	destination: string;

	@jsonProperty()
	mainFileSize: number;

	@jsonProperty(JSONMapper.classByMethods(AvdbLicenseInfo))
	license: AvdbLicenseInfo;

	@jsonProperty(JSONMapper.arrayOfClass(AvdbFileInfo))
	auxiliaryFiles: Array<AvdbFileInfo>;

	@jsonProperty(JSONMapper.arrayOfClass(AvdbSubregionMapDisplayInfo))
	displayInfo: Array<AvdbSubregionMapDisplayInfo>;

	@jsonProperty()
	territoryListTitle: string;

	@jsonProperty(JSONMapper.arrayOfClass(AvdbSubregion))
	subregions: Array<AvdbSubregion>;


	// Not using a getter since this is relatively expensive to compute and it will return a new
	// object each time
	getSubregionsByTerritory() {
		let map: Record<string, Array<string>> = {};

		for (let subregion of this.subregions) {
			for (let territory of subregion.territories) {
				if (map[territory] == null)
					map[territory] = [];
				map[territory].push(subregion.id);
			}
		}

		return map;
	}

	totalFileSizeForSubregions(subregionIDs: Set<String>) {
		if (subregionIDs == null || subregionIDs.size === 0 || this.subregions.length === 0)
			return this.totalFileSize;

		let totalFileSize = this.mainFileSize;
		let auxiliaryFilesForSubregions = this.auxiliaryFiles
			.filter(f => subregionIDs.has(f.subregionID));
		for (let file of auxiliaryFilesForSubregions) {
			totalFileSize += file.fileSize;
		}
		return totalFileSize;
	}
}
